import React from 'react';
import { Button } from '../Button';
import { Reveal } from '../Reveal';

export interface EmptyStateProps {
  icon: React.ElementType | React.ReactNode;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryActionLabel?: string;
  onSecondaryAction?: () => void;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  action,
}) => {
  // Check if icon is already a rendered element or a component to instantiate
  const renderIcon = () => {
    if (React.isValidElement(icon)) {
      return icon;
    }
    // Component (function or forwardRef object)
    const IconComponent = icon as React.ElementType;
    return <IconComponent className="w-10 h-10" />;
  };

  return (
    <Reveal variant="fade-up">
      <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
        <div className="w-20 h-20 rounded-2xl bg-neutral-800/50 flex items-center justify-center mb-6 text-neutral-500">
          {renderIcon()}
        </div>

        <h3 className="text-xl font-semibold text-white mb-2">{title}</h3>

        <p className="text-neutral-400 max-w-md mb-8">{description}</p>

        <div className="flex flex-col sm:flex-row gap-4">
          {action}

          {actionLabel && onAction && (
            <Button variant="primary" onClick={onAction}>
              {actionLabel}
            </Button>
          )}

          {secondaryActionLabel && onSecondaryAction && (
            <Button variant="outline" onClick={onSecondaryAction}>
              {secondaryActionLabel}
            </Button>
          )}
        </div>
      </div>
    </Reveal>
  );
};
